import { render, staticRenderFns } from "./resumedetails.vue?vue&type=template&id=24f6df0e&scoped=true&"
import script from "./resumedetails.vue?vue&type=script&lang=js&"
export * from "./resumedetails.vue?vue&type=script&lang=js&"
import style0 from "./resumedetails.vue?vue&type=style&index=0&id=24f6df0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6df0e",
  null
  
)

export default component.exports